module.exports = require("./angular-socialshare.js");
require("./angular-socialshare.css");
require("./angular-socialshare.less");


/*****************
 ** WEBPACK FOOTER
 ** angular-socialshare (bower component)
 ** module id = 372
 ** module chunks = 1
 **/